import axios from "axios";
import config from "../config";

/**
 *
 * @returns Project templates of the marketplace
 */
export const getProjectTemplates = () => {
  const url = `${config.API_ADDRESS}/getProjectTemplates`;

  return axios(url, {
    method: "GET",
  }).then((res) => {
    return res.data;
  });
};

/**
 *
 * @returns Project categories
 */
export const getProjectCategories = () => {
  const url = `${config.API_ADDRESS}/projectCategories`;

  return axios(url, {
    method: "GET",
  }).then((res) => {
    return res.data;
  });
};
